import Chance from 'chance';
import { FORMATTED_TRIPS } from '../constants';
import messages from '../View/messages';

export const generateSeed = (pathname) => new Chance(pathname).natural();

/**
 * @description TextGen class handling the chance instance and generating the seed with some
 * helper functions for all three other TextGen classes
 */
class TextGen {
  constructor(pathname, intl) {
    this.intl = intl;
    this.chance = new Chance(pathname);
    this.seed = generateSeed(pathname);
  }

  /**
   * @description Creates an array of six possible variations to display the trip
   * @param {string} origin - Name of the origin city
   * @param {string} destination - Name of the destination city
   * @param {number} increment - Additional number added to seed to induce variations
   * @returns {string[]}
   */
  getFormattedTrips = (origin, destination, increment = 0) =>
    Array.from({ length: 6 }, (v, i) =>
      this.getFormattedTrip(origin, destination, i + increment),
    );

  /**
   * @description Creates one possible output for trip based on the seed
   * @param {string} origin - Name of the origin city
   * @param {string} destination - Name of the destination city
   * @param {number} increment - Additional number added to seed to induce variations (useful to induce variations inside a given page)
   * @returns {string}
   */
  getFormattedTrip = (origin, destination, increment = 0) =>
    this.intl.formatMessage(
      messages[
        FORMATTED_TRIPS[(this.seed + increment) % FORMATTED_TRIPS.length]
      ],
      { origin, destination },
    );

  /**
   * @description Formats an array into a string, using a separator and adding "and" keyword before the last item
   * @param {string[]} array - Array to stringify
   * @param {string} separator - Separator used to join array items
   * @returns {string} Stringified list
   */
  formatEnumeratingSentence = (array, separator) => {
    if (array.length > 1) {
      const last = array.pop();

      return `${array.join(separator)}, ${this.intl.formatMessage(
        messages.and,
      )} ${last}`;
    }

    return array[0];
  };
}

export { TextGen };
